import axios from 'axios';
import { getAccessToken } from '../../../accessToken';

const getBaseUrl = () => {
  // Cuando el frontend corre en localhost, conecta con la API local de Go (puerto 8090)
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return 'http://localhost:8090';
  }
  return process.env.VUE_APP_API_REST || '';
};

const getHeaders = (idUser) => {
  const token = getAccessToken();
  const headers = {};
  if (token) {
    headers['Authorization'] = token;
  }
  if (idUser) {
    headers['id_user'] = idUser;
  }
  return headers;
};

export default {
  // 0) Previsualizar extracto bancario (sin guardar)
  previsualizarExtracto(formData, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/preview`;
    return axios.post(url, formData, {
      headers: {
        ...getHeaders(idUser),
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 1) Cargar extracto bancario (CSV / XLSX)
  subirExtracto(formData, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/carga`;
    return axios.post(url, formData, {
      headers: {
        ...getHeaders(idUser),
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 2) Listar cargas efectuadas
  listarCargas(params = {}, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/cargas`;
    return axios.get(url, {
      headers: getHeaders(idUser),
      params,
    });
  },

  // 3) Listar extractos bancarios (movimientos) con filtros
  listarExtractos(params = {}, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/extractos`;
    return axios.get(url, {
      headers: getHeaders(idUser),
      params,
    });
  },

  // 4) Detalle de extracto y sus sugerencias/confirmaciones
  obtenerExtractoDetalle(extractoId, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/extractos/${extractoId}`;
    return axios.get(url, {
      headers: getHeaders(idUser),
    });
  },

  // 5) Confirmar sugerencia de conciliación
  confirmarConciliacion(extractoId, conciliacionId, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/extractos/${extractoId}/confirmar/${conciliacionId}`;
    return axios.post(url, {}, {
      headers: getHeaders(idUser),
    });
  },

  // 6) Rechazar sugerencia con observaciones
  rechazarConciliacion(extractoId, conciliacionId, observaciones, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/extractos/${extractoId}/rechazar/${conciliacionId}`;
    return axios.post(url, { observaciones }, {
      headers: getHeaders(idUser),
    });
  },

  // 7) Conciliar manualmente (N recibos a 1 extracto)
  conciliarManual(extractoId, recibos, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/extractos/${extractoId}/conciliar-manual`;
    return axios.post(url, { recibos }, {
      headers: getHeaders(idUser),
    });
  },

  // 8) Conciliación de Efectivo: resumen de cierres de caja vs depósitos en banco
  obtenerConciliacionEfectivo(params = {}, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/efectivo`;
    return axios.get(url, {
      headers: getHeaders(idUser),
      params,
    });
  },

  // 9) Resumen y Auditoría de Balance de Conciliación
  obtenerResumenBalance(params = {}, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/resumen-balance`;
    return axios.get(url, {
      headers: getHeaders(idUser),
      params,
    });
  },

  // 10) Buscar recibo por N° de Recibo exacto para Conciliación Manual
  buscarReciboPorNro(nroRecibo, idUser) {
    const url = `${getBaseUrl()}/api/esam/conciliacion/recibo-buscar`;
    return axios.get(url, {
      headers: getHeaders(idUser),
      params: { nro_recibo: nroRecibo },
    });
  },
};
